import axios from 'axios';

// 📢 IMPORTANT: Update this to match your backend path
const API_BASE_URL = 'https://oznuli.in/frontend/api';

const userApi = axios.create({
    baseURL: API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
});

// ✅ Automatically attach user JWT
userApi.interceptors.request.use(config => {
    const authToken = localStorage.getItem('userToken'); // 🔥 must match key used in AuthScreen.jsx
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
}, error => Promise.reject(error));

// ===============================================
// 🔹 OTP-BASED AUTHENTICATION
// ===============================================
export const sendUserOTP = (data) => userApi.post('/auth/send_otp.php', data);
export const verifyUserOTP = (data) => userApi.post('/auth/verify_otp.php', data);

// ===============================================
// 🔹 WEBSITE SETTINGS (Logo, etc.)
// ===============================================
export const fetchSettings = () => userApi.get('/settings/read.php');

// ===============================================
// 🔹 TOKEN VERIFICATION (optional auto-login)
// ===============================================
export const verifyUserToken = () => userApi.get('/auth/verify_token.php');

// PROFILE MANAGEMENT
export const fetchUserProfile = (data) => userApi.post('/profile/get_profile.php', data);
export const updateUserProfile = (data) => userApi.post('/profile/update_profile.php', data);

// ===============================================
// 🔹 SCRAP PRICE & ORDERING
// ===============================================
export const fetchScrapPrices = () => userApi.get('/products/read_prices.php');
export const placeOrder = (data) => userApi.post('/orders/place_order.php', data);

// ===============================================
// 🔹 USER ORDERS & CONTACT
// ===============================================
export const fetchUserOrders = (data) => userApi.post('/orders/fetch_orders.php',data);
export const fetchOrderById = (data) => userApi.post('/orders/fetch_by_id.php', data);

export const submitContact = (data) => userApi.post('/contact/submit_contact.php', data);
// HELP CENTER
export const fetchFaqs = () => userApi.get('/help/faqs.php');
export const fetchCustomerReviews = () => userApi.get('/help/reviews.php');

// Dashboard data
export const fetchCategories = () => userApi.get('/categories/read.php');
export const fetchActiveOffer = () => userApi.get('/offers/active_offer.php');
export const fetchProductsByCategory = (data) => userApi.post('/products/read_by_category.php', data);
export const fetchUserAddresses = (data) => userApi.post('/users/read_addresses.php', data);
export const fetchRoutes = (data) => userApi.post('/routes/read.php', data);
export const addAddress = (data) => userApi.post('/users/add_addresses.php', data);
export const updateAddress = (data) => userApi.post('/users/update_address.php', data);
export const fetchAvailableDates = () => userApi.get('/slot/available_dates.php');
export const fetchTimeSlots = (data) => userApi.get(`/slot/time_slots.php?date=${data.date}`);

export default userApi;
